import React from "react";
import { Button } from "../ui/button";

/**
 * Component for showing expanded pipeline details
 */
const PipelineDetails = ({ run, workspace, formatDateTime }) => {
  return (
    <div className="space-y-2">
      <div>
        <span className="font-semibold">Pipeline UUID:</span> {run.uuid}
      </div>
      <div>
        <span className="font-semibold">Created:</span>{" "}
        {formatDateTime(run.created_on)}
      </div>
      <div>
        <span className="font-semibold">Completed:</span>{" "}
        {formatDateTime(run.completed_on)}
      </div>
      <div>
        <span className="font-semibold">Status:</span> {run.state?.name}
      </div>
      <div>
        <span className="font-semibold">Result:</span> {run.status?.name || "-"}
      </div>
      <div className="mt-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() =>
            window.open(
              `https://bitbucket.org/${workspace}/${run.repository.slug}/pipelines/results/${run.uuid}`,
              "_blank"
            )
          }
        >
          View in Bitbucket
        </Button>
      </div>
    </div>
  );
};

export default PipelineDetails;
